import { Icon } from "@chakra-ui/react";
import {
  MdPerson,
  MdHome,
  MdOutlineCampaign,
  MdCreate,
  MdEvent,
  MdGames,
  MdVideogameAsset,
  MdRateReview,
  MdOutlineAttachMoney,
  MdBarChart,
  MdNotificationAdd,
  MdAutoAwesome,
} from "react-icons/md";

import Overview from "views/admin/default";
import Profile from "views/admin/profile";
import CampaignCreate from "./views/admin/campaign_create";
import SignIn from "./views/auth/signIn";
import SignUp from "./views/auth/signUp";
import Terms from "./views/auth/terms";
import Events from "./views/admin/events";
import ROAS from "./views/admin/roas";
import Retention from "views/admin/retention";
import InstallOverview from "views/admin/installOverview";
import ROASOverview from "views/admin/roasOverview";
import RoasCampaignCreate from "views/admin/campaign_create/roas";
import Invoices from "views/admin/invoices";
import NotficationManager from "views/admin/notificationManager";
import CreateNotification from "views/admin/notificationManager/upsert";
import CpaOverview from "views/admin/cpaOverview";
import CpaCampaignCreate from "views/admin/cpaCampaignCreate";
import Optimize from "views/admin/optimize";
import OptimizeDetail from "views/admin/optimize/detail";

const routes: RoutesType[] = [
  {
    name: "User Acquisition",
    layout: "/",
    path: "/ua",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: Overview,
    subRoutes: [
      {
        name: "CPI Campaigns",
        layout: "/",
        path: "/ua/cpi",
        component: InstallOverview,
      },
      {
        name: "ROAS Campaigns",
        layout: "/",
        path: "/ua/roas",
        component: ROASOverview,
      },
      {
        name: "CPA Campaigns",
        layout: "/",
        path: "/ua/cpa",
        component: CpaOverview,
      },
    ],
  },
  {
    name: "New Campaign (CPI)",
    layout: "/",
    path: "/ua/cpi/create",
    component: CampaignCreate,
  },
  {
    name: "New Campaign (CPA)",
    layout: "/",
    path: "/ua/cpa/create",
    component: CpaCampaignCreate,
  },
  {
    name: "New Campaign (ROAS)",
    layout: "/",
    path: "/ua/roas/create",
    component: RoasCampaignCreate,
  },
  {
    name: "New Campaign (ROAS)",
    layout: "/",
    path: "/ua/roas/create",
    component: RoasCampaignCreate,
  },
  {
    name: "Optimize",
    layout: "/",
    path: "/optimize",
    icon: (
      <Icon as={MdAutoAwesome} width="20px" height="20px" color="inherit" />
    ),
    component: Optimize,
  },
  {
    name: "Optimize",
    layout: "/",
    path: "/optimize/:cardId",
    component: OptimizeDetail,
  },
  {
    name: "Analytics",
    layout: "/",
    path: "/analytics",
    icon: (
      <Icon
        as={MdOutlineAttachMoney}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: ROAS,
  },
  {
    name: "Retention Analysis",
    layout: "/",
    path: "/retention",
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: Retention,
  },
  {
    name: "Events",
    layout: "/",
    path: "/events",
    icon: (
      <Icon as={MdVideogameAsset} width="20px" height="20px" color="inherit" />
    ),
    component: Events,
  },
  {
    name: "Notification Manager",
    layout: "/",
    path: "/notification-manager",
    icon: (
      <Icon as={MdNotificationAdd} width="20px" height="20px" color="inherit" />
    ),
    component: NotficationManager,
  },
  {
    name: "New Campaign (ROAS)",
    layout: "/",
    path: "/notification-manager/create",
    component: CreateNotification,
  },
  {
    name: "Account",
    layout: "/",
    path: "/account",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Profile,
  },
  {
    name: "Unpaid & Overdue Invoices",
    layout: "/",
    path: "/invoices",
    component: Invoices,
  },
  {
    name: "Login",
    layout: "/auth",
    path: "/login",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: SignIn,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "/register",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: SignUp,
  },
  {
    name: "Terms and Conditions",
    layout: "/auth",
    path: "/terms",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Terms,
  },
];

export default routes;
